import { render, staticRenderFns } from "./U.Pattern.List.vue?vue&type=template&id=d56df2da&"
import script from "./U.Pattern.List.vue?vue&type=script&lang=js&"
export * from "./U.Pattern.List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports